import {ConfirmationModal} from '@freckle/educator-materials/ts/components/confirmation-modal'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {confirmMergeModal} from './confirm-merge-modal.module.scss'

type Props = {
  show: boolean
  onConfirm: () => void
  onCancel: () => void
}

export default function ConfirmMergeModal(props: Props) {
  const {show, onCancel, onConfirm} = props
  const {t} = useSafeTranslation()

  return (
    <ConfirmationModal
      title={t('CONFIRM_MERGE_MODAL_TITLE')}
      showModal={show}
      yesText={t('CONFIRM_MERGE_MODAL_BUTTON_YES')}
      yesBtnDataTest="merge-confirmation-modal-confirm"
      noText={t('CONFIRM_MERGE_MODAL_BUTTON_NO')}
      noBtnDataTest="merge-confirmation-modal-cancel"
      onClickYes={onConfirm}
      onClose={onCancel}
      className={confirmMergeModal}
    >
      {t('CONFIRM_MERGE_MODAL_WARNING')}
    </ConfirmationModal>
  )
}
